<template>
  <form @submit.prevent="save()" class="ui small form">
    <h3 class="ui header">Configurações de Gerais</h3>
    <div class="field">
      <label for="general-host-setting"> Host </label>
      <input
        type="text"
        v-model="form.general_host"
        id="general-host-setting"
      />
    </div>
    <div class="field">
      <label for="general-host-setting">
        E-mail para envio de notificações
      </label>
      <input type="text" v-model="form.general_email" id="general-host-email" />
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      form: {
        general_host: null,
        general_email: null
      }
    };
  },

  methods: {
    setForm(settings) {
      const formKeys = Object.keys(this.form);
      settings.forEach(setting => {
        if (formKeys.includes(setting.key)) {
          this.form[setting.key] = setting.response;
        }
      });
    },

    getSettings() {
      return this.form;
    }
  }
};
</script>
